// eslint-disable-next-line import/prefer-default-export
export const defaultPagination = {
	current: 1,
	pageSize: 10,
	sortOrder: 'desc',
	sortField: 'created_at',
	total: 0
}
